let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("axJvf")).then(() => parcelRequire('fjRfo'));